import { render, staticRenderFns } from "./RequestValidationCard.vue?vue&type=template&id=5c0812cc"
import script from "./RequestValidationCard.vue?vue&type=script&lang=js"
export * from "./RequestValidationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports